module.exports = __webpack_public_path__ + "static/img/IMG_20240928_171531.27d398a2.jpg";